import { combineReducers } from "redux";
import notificationReducer from "./notificationReducer";
import userReducer from "./userReducer";
import locationReducer from "./locationReducer";
import notificationEmergencyOrderReducer from "./notificationEmergencyOrderReducer";
import uploadEmergencyOrderReducer from "./emergencyOrderUploadReducer";
import viewManualordersReducer from "./ViewManualOrdersReducer";
import ViewManualOrderAuditReducer from "./viewManualOrdersAuditDetailsReducer";
import manualOrdersReducer from "./manualOrdersReducer";
import processOrdersReducer from "./processOrdersReducer";
import approvalOrdersReducer from "./approvalManualOrderReducer";
import downloadManualordersReducer from "./downloadManualOrdersReducer";
import orderopportunitiesInCreateReducer from "./createReducer";
import downloadManualOrdersAuditReducer from "./downloadManualOrdersAuditReducer";
import goldenStoreReducer from "./goldenStoreReducer";
import reasonCodesReducer from "./reasonCodesReducer";
import uploadManualOrderReducer from "./manualUpload.reducer";
import notificationManualOrderReducer from "./notificationManualOrderReducer";
import cutOffTimeReducer from "./cutOffTimeReducer";
import addUserReducer from "./addUserReducer";
import rolesReducer from "./rolesReducer";
import createProcessOrderReducer from "./createProcessOrderReducer";
import createManualOrderStoresReducer from "./createManualOrderStoresReducer";
import notificationManualPOUploadReducer from "./notificationManualPOUploadReducer";
import uploadManualPoReducer from "./uploadManualPoReducer";
import poLifeCycleReducer from "./manualPoLifecycleReducer";
import createPOReducer from "./createPOReducer";
import purchaseOrderEnquiryReducer from "./manualPOEnquiryReducer";
import { searchPOReducer } from "./searchPOReducer";
import { suppliersReducer } from "./suppliersReducer";
import amendPoFetchOrdersReducer from "./amendPOReducer";
import poSearchOpportunitiesReducer from "./poSearchOpportunitiesReducer";
import { searchDoNotOrderListReducer } from "./searchDoNotOrderListReducer";
import { addDoNotOrderItemsReducer } from "./addDoNotOrderListReducer";
import { removeDoNotOrderItemsReducer } from "./removeDoNotOrderListReducer";
import { searchSupplierDestinationMappingReducer } from "./searchSupplierDestinationMappingReducer";
import { removeSupplierDestinationMappingReducer } from "./removeSupplierDestinationMappingReducer";
import { addSupplierDestinationMappingReducer } from "./addSupplierDestinationMappingReducer";
import { downloadMaxCapReportReducer } from "./downloadMaxCapReportReducer";
import { bulkDeleteMaxCapReducer } from "./bulkDeleteMaxCapReducer";
import { searchMaxCapReducer } from "./searchMaxCapReducer";
import { addMaxCapReducer } from "./addMaxCapReducer";
import { bulkUpdateMaxCapReducer } from "./bulkUpdateMaxCapReducer";
import { updateSelectedMaxCapReducer } from "./updateSelectedMaxCapReducer";

export const rootReducer = combineReducers({
  user: userReducer,
  notification: notificationReducer,
  locations: locationReducer,
  EmergencyOrderNotification: notificationEmergencyOrderReducer,
  uploadEmergencyOrderFile: uploadEmergencyOrderReducer,
  viewManualorders: viewManualordersReducer,
  downloadManualordersReducer: downloadManualordersReducer,
  downloadManualOrdersAuditReducer: downloadManualOrdersAuditReducer,
  orders: ViewManualOrderAuditReducer,
  manualOrders: manualOrdersReducer,
  processOrders: processOrdersReducer,
  approval: approvalOrdersReducer,
  orderOpp: orderopportunitiesInCreateReducer,
  createOrder: orderopportunitiesInCreateReducer,
  goldenStore: goldenStoreReducer,
  reasonCodes: reasonCodesReducer,
  uploadManualOrderFile: uploadManualOrderReducer,
  ManualOrderNotification: notificationManualOrderReducer,
  cutOffTime: cutOffTimeReducer,
  roles: rolesReducer,
  addUser: addUserReducer,
  createProcessOrder: createProcessOrderReducer,
  createManualOrderStores: createManualOrderStoresReducer,
  notoficationManualPOUpload: notificationManualPOUploadReducer,
  purchaseOrderUpload: uploadManualPoReducer,
  purchaseOrderLifecycle: poLifeCycleReducer,
  createPO: createPOReducer,
  purchaseOrderEnquiry: purchaseOrderEnquiryReducer,
  searchPO: searchPOReducer,
  suppliers: suppliersReducer,
  poAmendPatch: amendPoFetchOrdersReducer,
  poSearchOpportunities: poSearchOpportunitiesReducer,
  searchDNOList: searchDoNotOrderListReducer,
  addDNOItems: addDoNotOrderItemsReducer,
  removeDNOItems: removeDoNotOrderItemsReducer,
  searchSupplierDestinationMapping: searchSupplierDestinationMappingReducer,
  addSupplierDestinationMapping: addSupplierDestinationMappingReducer,
  removeSupplierDestinationMapping: removeSupplierDestinationMappingReducer,
  downloadMaxCapReport: downloadMaxCapReportReducer,
  bulkDeleteMaxCap: bulkDeleteMaxCapReducer,
  searchMaxCap: searchMaxCapReducer,
  addMaxCap: addMaxCapReducer,
  bulkUpdateMaxCap: bulkUpdateMaxCapReducer,
  updateSelectedMaxCap: updateSelectedMaxCapReducer
});
